// ======================================================================
// File Name       : ContentAction
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import moment from 'moment';
import * as ActionTypes from '../../constants/actionTypes/content';
import { DATA_AFFIILIATION_TYPE } from '../../constants/ContentConstant';
import { DEFAULT_DATE_FORMAT_SERVER, RETURN_MAX_NUM } from '../../constants/index';
import * as actionCreators from '../actionCreators/content';
import * as httpRequests from '../httpRequests/content';

export function searchContent({
  contentSecernIds,
  contentName,
  contentType,
  drillTypeForItem,
  createdDateFrom,
  createdDateTo,
  dataAffiliationType,
  remark,
  contentSortType,
  ascendingDescendingSort,
  startPosition,
  returnMaxNum,
  excludeQuestion,
}) {
  return (dispatch) => {
    const searchInfo = {};
    const { INTERNAL, EXTERNAL } = DATA_AFFIILIATION_TYPE;
    contentSecernIds && (searchInfo.contentSecernId = contentSecernIds);
    contentName && (searchInfo.contentName = contentName);
    !isNaN(parseInt(contentType, 10)) && (searchInfo.contentType = contentType);
    drillTypeForItem && (searchInfo.drillTypeForItem = drillTypeForItem);
    createdDateFrom && (searchInfo.createdDateFrom = moment(createdDateFrom).startOf('day').format(DEFAULT_DATE_FORMAT_SERVER));
    createdDateTo && (searchInfo.createdDateTo = moment(createdDateTo).endOf('day').format(DEFAULT_DATE_FORMAT_SERVER));
    contentSortType !== null && (searchInfo.contentSortType = contentSortType);
    ascendingDescendingSort !== null &&
      (searchInfo.ascendingDescendingSort = ascendingDescendingSort);
    [INTERNAL, EXTERNAL].indexOf(dataAffiliationType) > -1 &&
      (searchInfo.dataAffiliationType = dataAffiliationType);
    remark && (searchInfo.remark = remark);
    searchInfo.startPosition = startPosition || 0;
    searchInfo.returnMaxNum = returnMaxNum || RETURN_MAX_NUM;
    excludeQuestion && (searchInfo.excludeQuestion = excludeQuestion);
    return httpRequests.getContentList({ searchInfo }).then((apiRes) => {
      dispatch(receiveContentList(startPosition, apiRes));
    });
  };
}

export function initContentEditing(secernId) {
  if (secernId) {
    return (dispatch) => {
      httpRequests.getContentList().then((resData) => {
        dispatch(receiveContentList(resData));
        dispatch(doInitContentEditing(secernId));
      });
    };
  }
  return doInitContentEditing(secernId);
}

export function editingContent(key, value) {
  return doReceiveContentEditing({ [key]: value });
}

function receiveContentList(startPosition, apiRes) {
  const { recordNum, contentList } = apiRes;
  return {
    type: ActionTypes.CONTENT_RECEIVE_LIST,
    startPosition,
    recordNum,
    contentList,
  };
}

function doInitContentEditing(secernId) {
  return {
    type: ActionTypes.CONTENT_INIT_EDITING,
    secernId,
  };
}

function doReceiveContentEditing(payload) {
  return {
    type: ActionTypes.CONTENT_RECEIVE_EDITING,
    payload,
  };
}

export function initContentList(searchCondition) {
  return (dispatch) => {
    const searchList = {};
    if (searchCondition) {
      dispatch(searchContent(searchCondition));
    } else {
      dispatch(searchContent(searchList));
    }
  };
}

function registerContentDrillAddedQuestion(data, drillGroupId) {
  return {
    type: ActionTypes.CONTENT_DRILL_REGISTER_ADD_QUESTION,
    data,
    drillGroupId,
  };
}

export function updateDialogSearchInfo(searchInfo) {
  return {
    type: ActionTypes.CONTENT_DRILL_REGISTER_UPDATE_QUESTION_DIALOG_SEARCH_INFO,
    searchInfo,
  };
}

export function resetDialogQuestionSearchInfo() {
  return {
    type: ActionTypes.CONTENT_DRILL_REGISTER_RESET_QUESTION_DIALOG_SEARCH_INFO,
  };
}

export function resetDialogQuestion() {
  return {
    type: ActionTypes.CONTENT_DRILL_REGISTER_RESET_QUESTION_DIALOG,
  };
}

export function registerContentDrillAddQuestion(questionDataListTemp, drillGroupId) {
  return (dispatch, getState) => {
    const selectedQuestionList = [];
    questionDataListTemp && questionDataListTemp.forEach((questionId) => {
      selectedQuestionList.push(questionId);
    }, this);
    dispatch(registerContentDrillAddedQuestion(selectedQuestionList, drillGroupId));
    dispatch(resetDialogQuestionSearchInfo());
  };
}

export function registerContentDrillDeleteQuestion(drillGroupId, questionId) {
  return {
    type: ActionTypes.CONTENT_DRILL_REGISTER_DELETE_QUESTION,
    drillGroupId,
    questionId,
  };
}

function registerContentDrillAddedFile(fileName, file) {
  return {
    type: ActionTypes.CONTENT_DRILL_REGISTER_ADD_FILE,
    fileName,
    file,
  };
}

export function registerContentDrillAddFile(file) {
  return (dispatch, getState) => {
    const fileName = file.name;
    if (fileName === '') {
      return;
    }
    dispatch(registerContentDrillAddedFile(fileName, file));
  };
}

function registerContentDrillGotSkinSet(data) {
  return {
    type: ActionTypes.CONTENT_DRILL_REGISTER_GET_SKIN_SET,
    data,
  };
}

export function registerContentDrillGetSkinSet() {
  return (dispatch) => {
    httpRequests.getSkinList().then((camelizeJson) => {
      dispatch(registerContentDrillGotSkinSet(camelizeJson));
    });
  };
}

function registeredContentDrillData(data) {
  return {
    type: ActionTypes.CONTENT_DRILL_REGISTER_DATA,
    data,
  };
}

export function registerContentDrillData(params) {
  return (dispatch) => {
    httpRequests.registerContentDrill(params).then((result) => {
      dispatch(registeredContentDrillData(result));
    });
  };
}

export function resetContentDrillRegisterData(data) {
  return {
    type: ActionTypes.CONTENT_DRILL_REGISTER_RESET_DATA,
    data,
  };
}

export function resetContentDrillEditData() {
  return {
    type: ActionTypes.CONTENT_DRILL_EDIT_RESET_DATA,
  };
}

function receiveData(resData, type) {
  return {
    type,
    resData,
  };
}

export function getListImportedFile(options) {
  return (dispatch) => {
    const PARAM_DEFAULT = {
      returnMaxNum: RETURN_MAX_NUM,
    };
    httpRequests.sendGetDrillListFileRequest(PARAM_DEFAULT, options).then((resdata) => {
      dispatch(receiveFileList(resdata));
    });
  };
}

function receiveFileList({ recordNum, importResultList }) {
  return {
    type: ActionTypes.RECEIVED_IMPORTED_FILE_LIST,
    recordNum,
    importResultList,
  };
}

export function importDrillList(data, options) {
  return (dispatch) => {
    httpRequests.sendDrillImportRequest(data, options).then((resdata) => {
      dispatch(receiveData(resdata, ActionTypes.IMPORT_DRILL_LIST));
    });
  };
}

function editContentDrillGotSkinSet(data) {
  return {
    type: ActionTypes.CONTENT_DRILL_EDIT_GET_SKIN_SET,
    data,
  };
}

export function editContentDrillGetSkinSet() {
  return (dispatch) => {
    httpRequests.getSkinList().then((camelizeJson) => {
      dispatch(editContentDrillGotSkinSet(camelizeJson));
    });
  };
}

function receivedContentNotificationList(data) {
  return {
    type: ActionTypes.CONTENT_NOTIFICATION_SEARCH,
    data,
  };
}

export function contentNotificationSearch(params) {
  return dispatch => httpRequests.searchNotificationMessage(params).then((result) => {
    dispatch(receivedContentNotificationList(result));
  });
}

export function downloadContentNotificationMessage(params) {
  return (dispatch) => {
    httpRequests.downloadNotificationMessage(params).then((result) => {
      if (result.zipfileUrl) {
        const link = document.createElement('a');
        link.href = result.zipfileUrl;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    });
  };
}

export function initDataContentNotificationRegisterEdit(data, isExist) {
  return {
    type: ActionTypes.CONTENT_NOTIFICATION_REGISTER_EDIT_INIT,
    data,
  };
}

function registeredContentNotificationMessage(data) {
  return {
    type: ActionTypes.CONTENT_NOTIFICATION_REGISTER,
    data,
  };
}

export function registerContentNotificationMessage(params) {
  return (dispatch) => {
    httpRequests.registerNotificationMessage(params).then((result) => {
      if (result) {
        dispatch(registeredContentNotificationMessage(result));
      }
    });
  };
}

function updatedContentNotificationMessage(data) {
  return {
    type: ActionTypes.CONTENT_NOTIFICATION_UPDATE,
    data,
  };
}

export function updateContentNotificationMessage(params) {
  return (dispatch) => {
    httpRequests.updateNotificationMessage(params).then((result) => {
      if (result) {
        dispatch(updatedContentNotificationMessage(result));
      }
    });
  };
}

export function resetContentNotificationRegister() {
  return {
    type: ActionTypes.CONTENT_NOTIFICATION_REGISTER_RESET,
  };
}

function deletedContentNotificationMessage(result) {
  return {
    type: ActionTypes.CONTENT_NOTIFICATION_DELETE,
    data: result,
  };
}

export function deleteContentNotificationMessage(params) {
  return (dispatch) => {
    httpRequests.deleteNotificationMessage(params).then((result) => {
      dispatch(deletedContentNotificationMessage(result));
    });
  };
}

export function createValueAttributeItemDrill() {
  return {
    type: ActionTypes.CREATE_VALUE_ATTRIBUTE_ITEM_DRILL,
  };
}

export function getQuestionListDrillDetail(data) {
  return async (dispatch) => {
    if (data && data.length) {
      const questionInfo = {};
      questionInfo.questionSecernIdList = data;
      const questionList = await httpRequests.getQuestionListDrillDetail({ questionInfo });
      return dispatch(actionCreators.getQuestionListDrillDetail(questionList));
    }
    return null;
  };
}

export function removeQuestionListDrill() {
  return {
    type: ActionTypes.REMOVE_QUESTION_LIST_DRILL,
  };
}

export function removeAllQuestionFromList(drillGroupId) {
  return {
    type: ActionTypes.REMOVE_ALL_QUESTION_FROM_LIST,
    drillGroupId,
  };
}

export function removeGroup(drillGroupId) {
  return {
    type: ActionTypes.REMOVE_GROUP,
    drillGroupId,
  };
}

export function addGroup(drillGroupId) {
  return {
    type: ActionTypes.ADD_GROUP,
    drillGroupId,
  };
}
